import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { EnvelopeSimple, ArrowRight, CheckCircle } from "@phosphor-icons/react";

export default function NewsletterSignup({ username, accent }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post(`/sites/${username}/subscribe`, { email, name });
      setDone(true);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Subscription failed");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="border-y border-border py-8 my-8 text-center" data-testid="newsletter-success">
        <CheckCircle size={28} weight="duotone" className="mx-auto" style={{ color: accent }} />
        <div className="font-serif text-2xl font-bold mt-3">You're on the list.</div>
        <p className="text-sm text-muted-foreground mt-1">New essays will land directly in your inbox.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border-y border-border py-8 my-8" data-testid="newsletter-form">
      <div className="grid grid-cols-12 gap-6 items-center">
        <div className="col-span-12 md:col-span-4">
          <div className="eyebrow flex items-center gap-2" style={{ color: accent }}>
            <EnvelopeSimple size={14} weight="duotone" /> The mailing list
          </div>
          <h3 className="font-serif text-3xl font-black tracking-tight mt-2 leading-tight">Get new essays by email.</h3>
          <p className="text-sm text-muted-foreground mt-2">No spam. Unsubscribe anytime.</p>
        </div>
        <div className="col-span-12 md:col-span-8 grid grid-cols-1 sm:grid-cols-12 gap-3">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name (optional)"
            className="sm:col-span-5 h-12 px-3 bg-card border border-border focus:outline-none focus:border-foreground"
            data-testid="newsletter-name-input"
          />
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="sm:col-span-5 h-12 px-3 bg-card border border-border focus:outline-none focus:border-foreground font-mono"
            data-testid="newsletter-email-input"
          />
          <button
            type="submit"
            disabled={busy}
            className="sm:col-span-2 h-12 px-4 inline-flex items-center justify-center gap-2 text-white text-sm font-medium hover:opacity-90 transition-opacity"
            style={{ background: accent }}
            data-testid="newsletter-submit-button"
          >
            {busy ? "..." : (<ArrowRight size={18} weight="bold" />)}
          </button>
          {err ? <div className="sm:col-span-12 text-sm text-destructive" data-testid="newsletter-error">{err}</div> : null}
        </div>
      </div>
    </form>
  );
}
